<div class="adash">

  <header class="adash__head">
    <h1 class="adash__title">
      <i class="fa-solid fa-gauge-high"></i>
      {{ 'ADMIN_HOME.TITLE' | translate }}
    </h1>
    <p class="adash__sub">{{ 'ADMIN_HOME.SUBTITLE' | translate }}</p>
  </header>

  <app-identity-banner
    [name]="currentUserName"
    [avatar]="currentUserAvatar"
    kind="supervisor"></app-identity-banner>

  @if (errored()) {
    <!-- Erreur de chargement : jamais de chiffres de substitution -->
    <app-error-state titleKey="ADMIN_HOME.ERROR_TITLE"
                     messageKey="ADMIN_HOME.ERROR_DESC"
                     (retry)="reload()"></app-error-state>
  } @else if (loading()) {
    <div class="adash__grid">
      @for (_ of [1,2,3,4,5,6,7,8]; track $index) {
        <div class="adash__skeleton"></div>
      }
    </div>
  } @else {

    <!-- ─── Effectifs ────────────────────────────────────────────── -->
    <section class="adash__section">
      <h2 class="adash__section-title">{{ 'ADMIN_HOME.PEOPLE' | translate }}</h2>
      <div class="adash__grid">
        @for (t of people(); track t.labelKey) {
          <ng-container [ngTemplateOutlet]="tile" [ngTemplateOutletContext]="{ $implicit: t }"></ng-container>
        }
      </div>
    </section>

    <!-- ─── Activité et actions en attente ───────────────────────── -->
    <section class="adash__section">
      <h2 class="adash__section-title">{{ 'ADMIN_HOME.ACTIVITY' | translate }}</h2>
      <div class="adash__grid">
        @for (t of activity(); track t.labelKey) {
          <ng-container [ngTemplateOutlet]="tile" [ngTemplateOutletContext]="{ $implicit: t }"></ng-container>
        }
      </div>
    </section>
  }

  <!-- Une tuile mène à son écran si le compte peut l'ouvrir ; sinon elle garde
       son chiffre et perd son lien, plutôt que de conduire à un refus. -->
  <ng-template #tile let-t>
    @if (t.open) {
      <a class="adash-tile" [class.is-alert]="t.alert" [routerLink]="t.link">
        <ng-container [ngTemplateOutlet]="tileBody" [ngTemplateOutletContext]="{ $implicit: t }"></ng-container>
      </a>
    } @else {
      <div class="adash-tile adash-tile--closed" [class.is-alert]="t.alert"
           [attr.title]="'ADMIN_HOME.TILE_NO_ACCESS' | translate">
        <ng-container [ngTemplateOutlet]="tileBody" [ngTemplateOutletContext]="{ $implicit: t }"></ng-container>
      </div>
    }
  </ng-template>

  <ng-template #tileBody let-t>
    <span class="adash-tile__icon"><i [class]="t.icon"></i></span>
    <span class="adash-tile__value">{{ t.value }}</span>
    <span class="adash-tile__label">{{ t.labelKey | translate }}</span>
  </ng-template>

  <!-- ─── Notifications réelles ──────────────────────────────────── -->
  <section class="adash__section">
    <h2 class="adash__section-title">
      {{ 'ADMIN_HOME.NOTIFICATIONS' | translate }}
    </h2>

    @if (notificationsLoading()) {
      <p class="adash__hint">{{ 'LOADINGS.LOADING' | translate }}</p>
    } @else if (notifications().length === 0) {
      <p class="adash__hint">{{ 'ADMIN_HOME.NO_NOTIFICATION' | translate }}</p>
    } @else {
      <ul class="adash-notif">
        @for (n of notifications(); track n.id) {
          <li class="adash-notif__row" [class.is-unread]="!n.isRead">
            <span class="adash-notif__dot"></span>
            <span class="adash-notif__body">
              <span class="adash-notif__title">{{ n.title }}</span>
              <span class="adash-notif__msg">{{ n.message }}</span>
            </span>
            <span class="adash-notif__time">{{ n.createdAt | date:'dd/MM HH:mm' }}</span>
          </li>
        }
      </ul>
    }
  </section>

</div>
